import axios from "axios"

const api = axios.create({
  baseURL: 'https://update.veloximaging.net/', 
  timeout: 600000,
});

export default api;
